// src/views/ConsultantLogin.jsx
// Connexion CONSULTANT — page et endpoint séparés de l'espace créateur.
//   URL front : /consultant/login
//   API       : POST {base_url}login/consultant

import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, Eye, EyeOff, Briefcase } from "lucide-react";
import { loginConsultant } from "../services/ConsultantService";
import { estConsultant, peutAgirPour } from "../utils/agirPour";

const VIOLET = "#481699";

export default function ConsultantLogin() {
    const navigate = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [voir, setVoir] = useState(false);
    const [loading, setLoading] = useState(false);
    const [erreur, setErreur] = useState("");

    // Déjà connecté → dashboard
    useEffect(() => {
        if (estConsultant() && peutAgirPour()) navigate("/consultant", { replace: true });
    }, [navigate]);

    const envoyer = async (e) => {
        e.preventDefault();
        setErreur("");
        if (!email || !password) { setErreur("Remplissez tous les champs."); return; }
        setLoading(true);
        try {
            await loginConsultant(email.trim(), password);
            navigate("/consultant", { replace: true });
        } catch (err) {
            setErreur(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-black flex items-center justify-center px-4">
            <form onSubmit={envoyer} className="w-full max-w-sm bg-white/5 border border-white/10 rounded-2xl p-6 flex flex-col gap-4">
                <div className="flex flex-col items-center gap-2 mb-2">
                    <div className="w-12 h-12 rounded-2xl flex items-center justify-center" style={{ backgroundColor: VIOLET }}>
                        <Briefcase className="text-white" size={22} />
                    </div>
                    <h1 className="text-white text-xl font-bold">Espace consultant</h1>
                    <p className="text-white/50 text-xs text-center">Thrundrz — accès réservé aux consultants</p>
                </div>

                <label className="flex flex-col gap-1.5">
                    <span className="text-white text-sm">Email</span>
                    <input
                        type="email" autoComplete="email" value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        data-testid="consultant-email"
                        className="w-full px-4 py-3 rounded-xl text-black text-base sm:text-sm outline-none focus:ring-2 focus:ring-purple-500"
                    />
                </label>

                <label className="flex flex-col gap-1.5">
                    <span className="text-white text-sm">Mot de passe</span>
                    <div className="relative">
                        <input
                            type={voir ? "text" : "password"} autoComplete="current-password" value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            data-testid="consultant-password"
                            className="w-full px-4 py-3 pr-11 rounded-xl text-black text-base sm:text-sm outline-none focus:ring-2 focus:ring-purple-500"
                        />
                        <button type="button" onClick={() => setVoir((v) => !v)}
                            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">
                            {voir ? <EyeOff size={18} /> : <Eye size={18} />}
                        </button>
                    </div>
                </label>

                {erreur && <p className="text-red-300 text-sm" data-testid="consultant-erreur">{erreur}</p>}

                <button
                    type="submit" disabled={loading} data-testid="consultant-submit"
                    className="flex items-center justify-center gap-2 py-3 rounded-xl text-white font-bold disabled:opacity-60"
                    style={{ backgroundColor: VIOLET }}
                >
                    {loading && <Loader2 size={18} className="animate-spin" />}
                    {loading ? "Connexion…" : "Se connecter"}
                </button>
            </form>
        </div>
    );
}